import { render, staticRenderFns } from "./swCompanyCountries.vue?vue&type=template&id=00474481&scoped=true"
import script from "./swCompanyCountries.vue?vue&type=script&lang=js"
export * from "./swCompanyCountries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00474481",
  null
  
)

export default component.exports